module.exports = __webpack_public_path__ + "static/media/linkedin.b5143d43.webp";